/* Copyright 2013 - 2024 Waiterio LLC */

const context = import.meta.webpackContext('./pages', {
  recursive: true,
  regExp: /\.\/(?!.*\.test\.js$).*\.js$/,
})

export default context
